export const FUNDING_PATHS = {
  APPLICATIONS_LIST: '/grants/applications',
  HOW_TO_APPLY: '/grants/how-to-apply',
  APPLY: '/grants/apply',
  REPORTS: '/grants/grantee-reports',
  GRANTEE_REPORT: '/grants/GranteeReport',
  REPORT: '/grants/report',
  REPORT_PREVIEW: '/grants/report-preview',
  PREQUALIFICATION: '/grants/prequalification',
  GRANT_APPLICATION: '/grants/grant-application'
} as const
